// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__1KhrZ","errorLogs":"styles_errorLogs__1VjwJ"};